import { Link } from "react-router-dom";
import { Instagram, Linkedin } from "lucide-react";
import { useT } from "../lib/LanguageContext";

export const Footer = ({ variant = "default" }) => {
  const { t } = useT();
  if (variant === "contact") {
    return (
      <footer data-testid="site-footer" className="px-6 md:px-10 pb-16 pt-10 bg-white">
        <div className="max-w-6xl mx-auto bg-[#FFFBEA] rounded-[40px] px-8 md:px-16 py-12 md:py-16 grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <p className="text-xs uppercase tracking-[0.25em] text-[#6B5CE7] mb-4 font-medium">
              {t("footer.joindre")}
            </p>
            <a href="tel:+33789335568" data-testid="footer-phone" className="font-serif text-2xl text-[#1A1528] hover:text-[#6B5CE7] transition-colors">
              +33 7 89 33 55 68
            </a>
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.25em] text-[#6B5CE7] mb-4 font-medium">
              {t("footer.mail")}
            </p>
            <a href="mailto:evara.monaco@gmail.com" data-testid="footer-email" className="font-serif text-xl text-[#1A1528] hover:text-[#6B5CE7] transition-colors break-all">
              evara.monaco@gmail.com
            </a>
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.25em] text-[#6B5CE7] mb-4 font-medium">
              {t("footer.sabonner")}
            </p>
            <div className="flex gap-3">
              <a href="https://instagram.com" target="_blank" rel="noreferrer" data-testid="footer-instagram" className="w-11 h-11 rounded-full bg-white border border-[#1A1528]/15 flex items-center justify-center text-[#1A1528] hover:bg-[#6B5CE7] hover:text-white hover:border-transparent transition-all">
                <Instagram size={18} />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noreferrer" data-testid="footer-linkedin" className="w-11 h-11 rounded-full bg-white border border-[#1A1528]/15 flex items-center justify-center text-[#1A1528] hover:bg-[#6B5CE7] hover:text-white hover:border-transparent transition-all">
                <Linkedin size={18} />
              </a>
            </div>
          </div>
        </div>
        <FooterLegal t={t} />
      </footer>
    );
  }

  return (
    <footer data-testid="site-footer" className="px-6 md:px-10 py-10 bg-white border-t border-[#f0e8c8]/70">
      <FooterLegal t={t} />
    </footer>
  );
};

const FooterLegal = ({ t }) => (
  <div className="max-w-7xl mx-auto pt-8 mt-8 flex flex-col md:flex-row gap-4 md:gap-0 justify-between items-start md:items-center text-[12px] uppercase tracking-[0.2em] text-[#4A4558]">
    <div className="flex flex-wrap gap-x-8 gap-y-2">
      <Link to="/legal/cookies" data-testid="footer-cookies" className="hover:text-[#6B5CE7] transition-colors">{t("footer.cookies")}</Link>
      <Link to="/legal/mentions" data-testid="footer-mentions" className="hover:text-[#6B5CE7] transition-colors">{t("footer.mentions")}</Link>
      <Link to="/legal/confidentialite" data-testid="footer-confidentialite" className="hover:text-[#6B5CE7] transition-colors">{t("footer.confidentialite")}</Link>
    </div>
    <p data-testid="footer-copyright">{t("footer.copyright")}</p>
  </div>
);
